<template>
  <v-autocomplete
    id="customerSearchComp"
    v-model="customer"
    label="Müşteri Seçimi"
    :placeholder="customerLoading ? 'Yükleniyor' : 'Lütfen müşteri seçiniz'"
    clearable
    persistent-placeholder
    :items="customerItems"
    :filter="filterObject"
    :disabled="customerLoading"
    filled
    background-color="grey"
    hide-details
    attach
    rounded
    class="customerSearchComp"
    item-text="name1"
    item-value="customer"
    :menu-props="{ bottom: true, offsetY: true }"
    @change="customerChange"

  >
    <template v-slot:item="data">
      <v-chip
        v-if="!$vuetify.breakpoint.mdAndDown"
        style="min-width: 140px"
        label
        color="warning"
        outlined
        class="mr-3 d-flex justify-center"
      >
        {{ data.item.customer }}
      </v-chip>
      <div>
        <div class="text-subtitle-1 white--text text-truncate">
          {{ baslikSplit(data.item.name1, 0) }}
        </div>
        <div class="text-caption">
          {{ baslikSplit(data.item.name1, 1) }}
        </div>
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
import { mdiDomain } from "@mdi/js";
import { postData } from "@utils";
import store from "@/store";
import { useAppStore } from "@/stores/app";
import { onMounted, ref, watch } from "@vue/composition-api";
import { useRouter } from "@core/utils";
import Vue from "vue";
export default {
  setup() {
    const appStore = useAppStore();
    const { route } = useRouter();

    const filterObject = (item, queryText, itemText) =>
      item.customer.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 ||
      item.name1.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;

    const customer = ref(null);
    const customerItems = ref([]);
    const customerLoading = ref(false);
    onMounted(() => {
      customerLoading.value = true;
      appStore.loadingCustomer = true;

      postData({
        method: "sessionInfo",
      }).then((response) => {
        if (response.k_customer_no) {
          customer.value = response.k_customer_no;
          store.commit("PLASIYER_CUSTOMER", response.k_customer_no);
          appStore.selectedCustomer = response.k_customer_no;
        }
      });
      const data = {
        method: "getCustomersBySalDept",
        type: "select",
      };
      store
        .dispatch("postMethod", data)
        .then((response) => {
          customerItems.value = response.detail;
          customer.value = store.state.plasiyerCustomer;
        })
        .catch((e) => {
          Vue.swal({
            title: "Hata",
            text: e.message,
            width: "350px",
            icon: "error",
            background: "#FF4C51",
            showCloseButton: false,
            showConfirmButton: true,
            confirmButtonColor: "#cc3d41",
          });
        })
        .finally(() => {
          customerLoading.value = false;
          appStore.loadingCustomer = false;
        });
    });

    const customerChange = () => {
      const data = {
        method: "changeActiveCustomer",
        customer: customer.value || null,
      };
      store
        .dispatch("postMethod", data)
        .then((response) => {
          if (response.error == 1) {
            throw new Error(response.msg);
          }

          store.commit("PLASIYER_CUSTOMER", response.detail?.customer);
          appStore.selectedCustomer = response.detail?.customer;
        })
        .catch((e) => {
          Vue.swal({
            title: "Hata",
            text: e.message,
            width: "350px",
            icon: "error",
            background: "#FF4C51",
            showCloseButton: false,
            showConfirmButton: true,
            confirmButtonColor: "#cc3d41",
          });
          customer.value = "";
        })
        .finally(() => {
          risk();

          customerLoading.value = false;
        });
    };

    const risk = () => {
      if (route.value.name === "order-to") return;
      store.dispatch("refreshRiskLimit");
    };

    const baslikSplit = (val, index) => {
      let result;
      if (val && val.split("/").length > 1) {
        const splitArray = val.split(" / ");
        if (splitArray[index]) {
          if (index === 0) {
            result = splitArray[index].slice(0, -1);
          } else {
            result = `${splitArray[index].slice(0, -1)}`;
          }
        } else {
          result = "";
        }
      } else if (index === 0) {
        result = val || "";
      } else {
        result = "";
      }

      return result;
    };

    watch(
      () => appStore.selectedCustomer,
      (val) => {
        if (val === null) {
          customer.value = null;
          // customerChange();
        }
      }
    );

    return {
      baslikSplit,
      filterObject,
      customerItems,
      customerLoading,
      customer,
      customerChange,
      icons: { mdiDomain },
    };
  },
};
</script>
<style>
.customerSearchComp .v-menu__content:not(.list-style) .v-list-item {
  height: 60px !important;
  border-bottom: 1px solid #403c55;
}
.customerSearchComp .v-menu__content {
  max-height: 70dvh !important;
  top: 60px !important;
  border-radius: 18px !important;
}
@media screen and (max-width: 1263px) {
  .customerSearchComp {
    margin-top: 18px !important;
    width: 100% !important;
    margin-bottom: 8px !important;
  }
  .customerSearchComp .v-menu__content {
    max-height: 100dvh !important;
    min-width: 116dvw !important;
    top: 70px !important;
  }
}
</style>
